import { IRespondedJob, IRespondedJobParams } from '@/interfaces/respondedJobs'
import { fetchItem, createItem } from '@/api/respondedJobs'
import axios from 'axios'
import * as Sentry from '@sentry/vue'

class NaRespondedJob {
  onError: (x?: any, args?: any) => void = () => {}
  onProgress: (jobId: string) => void = () => {}
  onExpired: () => void = () => {}
  afterJobCallBack: (job: IRespondedJob) => void = () => {}
  respondedJobId: number = 0

  constructor(
    onerror?: (error: string, args?: any) => void,
    onprogress?: (id: string) => void,
    onexpired?: () => void
  ) {
    if (onerror) {
      this.onError = onerror
    }
    if (onprogress) {
      this.onProgress = onprogress
    }
    if (onexpired) {
      this.onExpired = onexpired
    }
  }

  runRespondedJob(
    type: string,
    args: any,
    callback?: (job: IRespondedJob) => void
  ) {
    if (callback) {
      this.afterJobCallBack = callback
    }
    const payload = {
      type: type,
      args: args
    } as IRespondedJobParams

    createItem(payload)
      .then((response) => {
        this.checkJobWithInterval(response.data.id)
      })
      .catch((e) => {
        Sentry.captureException(e, {
          extra: { context: 'runRespondedJob', type, args }
        })
        this.onError('Failed to create responded job', args)
      })
  }

  setAfterJobCallback(callback: (job: IRespondedJob) => void) {
    this.afterJobCallBack = callback
  }

  checkJobWithInterval(jobId: string) {
    this.onProgress(jobId)
    this.respondedJobId = Number(jobId)
    this.checkJob()
  }

  destroy() {
    this.respondedJobId = 0
  }

  checkJob = () => {
    if (this.respondedJobId < 1) {
      return
    }
    fetchItem(this.respondedJobId)
      .then((response) => {
        if (response.data.attributes.success) {
          if (response.data.attributes.error) {
            this.onError(response.data.attributes.error, {
              ...response.data.attributes.args
            })
          } else {
            this.afterJobCallBack(response.data)
          }
        } else {
          this.onProgress(response.data.id)
          setTimeout(this.checkJob, 2000)
        }
      })
      .catch((e) => {
        if (axios.isAxiosError(e) && e.response?.status === 400) {
          this.onExpired()
        } else {
          Sentry.captureException(e, {
            extra: { context: 'checkJob', respondedJobId: this.respondedJobId }
          })
          this.onError('Failed to load report result', {})
        }
      })
  }
}

export default NaRespondedJob
